import React from 'react'
import PropTypes from 'prop-types'

import { DocumentFile } from '../../../../../../entities/DocumentFile'

import { DocumentAsset } from '../../../../../components/DocumentAsset/DocumentAsset'

import './Regulation.css'

const Regulation = ({ regulation, dark }) => (
    <>
        {regulation.hasHtmlDescription ? (
            <div className="regulation">
                <div className="regulation__info">
                    <div
                        className="regulation__info__description"
                        dangerouslySetInnerHTML={regulation.htmlDescription}
                    />
                </div>
                <div className="regulation__content">
                    <DocumentAsset asset={regulation} dark={dark} />
                </div>
            </div>
        ) : (
            <DocumentAsset asset={regulation} dark={dark} />
        )}
    </>
)

Regulation.propTypes = {
    regulation: PropTypes.instanceOf(DocumentFile)
}

export { Regulation }
